export default __webpack_public_path__ + "sample.csv";